// 261015 P2b-3 F5 — hộp "Chấp nhận (cảnh đã có chi tiết)…" ở ⑤ (C6): người gõ LÝ DO (10–300 ký tự) rằng một cảnh của tập ĐÃ có chi tiết gieo. Mọi quyết định (kiểm lý do, dựng body) ở `plantAcceptView.ts` (thuần, có jest).
// BE tự lấy người bấm từ token; chấp nhận hết hiệu lực khi cảnh của tập hoặc chi tiết gieo đổi (cảnh báo hiện lại).
import React, { useEffect, useState } from 'react';
import { Input, Modal, Space, Typography } from 'antd';
import { humanizeCodes } from '../adaptationUtils';
import { PLANT_ACCEPT_INPUT_MAX, canSubmitPlantAccept, plantAcceptReasonState } from './plantAcceptView';

const { Text } = Typography;

export interface PlantAcceptTarget { beatId: string; message: string }

interface Props {
  target: PlantAcceptTarget | null;
  episode: number;
  busy: boolean;
  onCancel: () => void;
  /** Caller tạo lượt KHÔNG AI + khối xem thử (người bấm Áp ở khung Trợ lý). */
  onSubmit: (beatId: string, reason: string) => void | Promise<void>;
}

const PlantAcceptModal: React.FC<Props> = ({ target, episode, busy, onCancel, onSubmit }) => {
  const [reason, setReason] = useState('');
  useEffect(() => { setReason(''); }, [target?.beatId, target?.message]);
  if (!target) return null;
  const state = plantAcceptReasonState(reason);
  const ok = canSubmitPlantAccept(target.beatId, reason);
  return (
    <Modal
      open title="Chấp nhận: cảnh đã có chi tiết gieo" okText="Chấp nhận" cancelText="Thôi" onCancel={onCancel}
      okButtonProps={{ disabled: !ok || busy, 'data-testid': 'plant-accept-ok' } as never} confirmLoading={busy}
      onOk={() => { if (ok) onSubmit(target.beatId, reason); }}
    >
      <Space direction="vertical" size={10} style={{ width: '100%' }}>
        <Text type="secondary" style={{ fontSize: 13 }}>{humanizeCodes(target.message)}</Text>
        <Text type="secondary" style={{ fontSize: 13 }}>
          Chỉ chấp nhận khi một cảnh của tập {episode} ĐÃ có chi tiết này (bằng hình hoặc thoại). Kịch bản không bị sửa: cảnh báo chuyển sang mục “Đã chấp nhận” kèm lý do, người chấp nhận và thời gian.
          Chấp nhận hết hiệu lực khi cảnh của tập hoặc chi tiết gieo đổi — cảnh báo sẽ hiện lại. Bạn bấm Áp ở khung Trợ lý để ghi.
        </Text>
        <div>
          <Input.TextArea
            value={reason} onChange={(e) => setReason(e.target.value)} rows={3} maxLength={PLANT_ACCEPT_INPUT_MAX} showCount
            placeholder="Cảnh nào đã có chi tiết gì? (vd: cảnh 3 — chiếc ô đỏ nằm trên bàn lúc Lan bước vào)"
            aria-label="Lý do chấp nhận"
          />
          {state.hint && reason.length > 0 && <Text type="danger" style={{ fontSize: 13 }}>{state.hint}</Text>}
        </div>
      </Space>
    </Modal>
  );
};

export default PlantAcceptModal;
